import { Pagination as RaPagination } from 'react-admin'
import { useCurrentPageStyles } from '../services/currentPage'

export const Pagination = (props) => {
  const { page } = props
  const classes = useCurrentPageStyles(page)()

  return <RaPagination className={classes.list} {...props} />
}
